<script>
    import WpImage from './WpImage'
    import BlockLinks from "./BlockLinks"
    import OnLoadAnimation from "../includes/OnLoadAnimation"
    import FadeAnimation from '../includes/FadeAnimation'
    import EventBusMixin from '../utils/mixinEventBus'
    import {EventBus} from '../utils/EventBus'

    export default {
        name: "ModuleMixin",
        mixins: [EventBusMixin],
        components: { WpImage, BlockLinks,FadeAnimation, OnLoadAnimation},
        computed: {
            background_image() {
                return this.module && this.module.background_image;
            },
            background_color() {
                return this.module && this.module.background_color;
            },
            wp_title() {
                return this.module && this.module.title || false;
            },
            wp_subtitle() {
                return this.module && this.module.subtitle || false;
            },
            wp_content() {
                return this.module && this.module.text || false;
            },
            links() {
                return this.module && this.module.links || [];
            },
            styles() {
                let backgroundColor = this.module && this.module.background_color;

                if (!backgroundColor)
                    return false;

                return `background:${backgroundColor};`;
            }
        },
        methods: {
            moduleLoaded() {
                this.$emit('moduleLoaded');
            },
            getAnimationComponent() {
                if (this.index && this.index > 0)
                    return FadeAnimation;
                else
                    return OnLoadAnimation;
            }
        },
        mounted() {
            jQuery('.news-section a').click((e)=> {
                e.preventDefault();
                EventBus.setPageLoaded(false);
            });
        }
    }
</script>

<style lang="scss" type="text/scss" >
    .module {
        display: block;
        min-height: 500px;
        position: relative;

        .fit-container {
            margin: 0 auto;
        }

        &.white-color {
            color: $theme-white;
        }

        &.full-height {
            min-height: 100vh;
        }

        &.text-center {
            h2 {
                &:after {
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }

        .text-center {
            h2 {
                &:after {
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }


        h2 {
            display: inline-block;
            position: relative;
            margin-bottom: 70px;
            margin-top: 0;

            &:after {
                background: $theme-brown;
                content: '';
                height: 5px;
                left: 0;
                position: absolute;
                bottom: -35px;
                width: 60px;
            }
        }

        .module-content {
            p {
                margin-top: 0;
            }

            a {
                color: $theme-green;
                font-weight: 600;
                text-decoration: underline;
            }
        }
    }

    .parallax-wrapper {
        position: absolute;
        min-height: 100vh;
        height: 100%;
        top: 0;
        width: 100%;
        z-index: -1;

        .module-background {
            background-position: center;
            min-height: 100vh;

            @media screen and (max-height: 500px){
                min-height: 500px;
            }
        }

        @media screen and (max-height: 500px){
            min-height: 500px;
        }
    }

    .background-overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    @media screen and (max-width: 860px) {

    }
</style>